(function() {
    'use strict';

    angular
        .module('irricrops')
        .factory('estadisticaFac', estadisticaFac);

    estadisticaFac.$inject = ['urls', '$resource'];

    /* @ngInject */
    function estadisticaFac(urls, $resource) {
      return $resource(urls.BASE+'/estadistica/:action', {},{

        getTemporadaCalidad:{
          method: "GET",
          params:{
            action: "temporada-calidad"
          }
        },

        getTemporadaSectorRiego:{
          method: "GET",
          params:{
            action: "temporada-sector-riego"
          }
        },

        getTemporadaVariedad:{
          method: "GET",
          params:{
            action: "temporada-variedad"
          }
        },

        getTemporadaVinedo:{
          method: "GET",
          params:{
            action: "temporada-vinedo"
          }
        },

        getVinedoIdeal : {
          method: "GET",
          params:{
            action: "comparacion-ideal"
          }
        },




        getResumenCalidad:{
          method: "GET",
          params:{
            action: "resumen-calidad"
          }
        },
        getResumenVariedad:{
          method: "GET",
          params:{
            action: "resumen-variedad"
          }
        },

        getMeses:{
          method: "GET",
          params:{
            action: "meses"
          }
        },
        getMesesCalidad:{
          method: "GET",
          params:{
            action: "meses-calidad"
          }
        },
        getMesesSectorRiego:{
          method: "GET",
          params:{
            action: "meses-sector-riego"
          }
        },
        getMesesVariedad:{
          method: "GET",
          params:{
            action: "meses-variedad"
          }
        },
        getMesesVinedo:{
          method: "GET",
          params:{
            action: "meses-vinedo"
          }
        },


        getEstadosCalidad:{
          method: "GET",
          params:{
            action: "estados-calidad"
          }
        },
        getEstadosSectorRiego:{
          method: "GET",
          params:{
            action: "estados-sector-riego"
          }
        },
        getIdealEstadosFenologicos:{
          method: "GET",
          params:{
            action: "comparacion-ideal-estados-fenologicos"
          }
        },
        getEstadosVariedad:{
          method: "GET",
          params:{
            action: "estados-variedad"
          }
        },
        getEstadosVinedo:{
          method: "GET",
          params:{
            action: "estados-vinedo"
          }
        },

      });
    }
})();
